import {
  apiErrorsInterceptor,
  apiHostInterceptor,
  authTokenInterceptor,
  refreshTokenInterceptor,
} from '../interceptors';

export const interceptors = [
  apiErrorsInterceptor,
  refreshTokenInterceptor,
  apiHostInterceptor,
  authTokenInterceptor,
];
